import { useMemo } from 'react';

import { RGBTuple } from './types';
import { getContrast, hexToRgb } from './utils';

type Details = {
    colorA?: RGBTuple;
    colorB?: RGBTuple;
    colorAContrast: number;
    colorBContrast: number;
};

type BestColorDetails = [string | null, Details | null];

const useBestColorForBackgroundColor = (
    colorA?: string,
    colorB?: string,
    backgroundColor?: string
): BestColorDetails => {
    const colorAContrast = useMemo<number>(() => {
        const rgbBackgroundColor = backgroundColor ? hexToRgb(backgroundColor) : undefined;
        const rgbColorA = colorA ? hexToRgb(colorA) : undefined;

        if (rgbColorA && rgbBackgroundColor) {
            return getContrast(rgbColorA, rgbBackgroundColor);
        }

        return 0;
    }, [backgroundColor, colorA]);

    const colorBContrast = useMemo<number>(() => {
        const rgbBackgroundColor = backgroundColor ? hexToRgb(backgroundColor) : undefined;
        const rgbColorB = colorB ? hexToRgb(colorB) : undefined;

        if (rgbColorB && rgbBackgroundColor) {
            return getContrast(rgbColorB, rgbBackgroundColor);
        }

        return 0;
    }, [backgroundColor, colorB]);

    if (colorA === undefined || colorB === undefined || backgroundColor === undefined) {
        return [null, null];
    }

    return [
        colorAContrast > colorBContrast ? colorA : colorB,
        {
            colorA: hexToRgb(colorA),
            colorB: hexToRgb(colorB),
            colorAContrast,
            colorBContrast,
        },
    ];
};

export default useBestColorForBackgroundColor;
